export default function StorySection() {
  return (
    <section className="bg-[#FDFAF8] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          The story behind the collection
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] text-center mb-10 leading-tight">
          I created this because I needed it myself, and it didn't exist.
        </h2>

        {/* Body — Mandie's voice */}
        <div className="max-w-3xl mx-auto">
          <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-6">
            For years, I sat with women in sessions and watched the same thing happen. They would leave with insight. With breakthroughs. With things they had never said out loud to another human being. And then they would go home, back to the noise, the roles, the demands, and within days, that clarity would start to fade. Not because the work wasn't real. But because there was no container for it outside of our sessions.
          </p>
          <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-6">
            I wanted to give women something they could hold. Something they could return to at 6am before the house woke up, or at midnight when everything felt too loud. The H.O.M.E Collection is that thing.
          </p>
          <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed">
            The journal gives you the depth. The card deck gives you the daily anchor. Together, they create a complete healing practice you can hold in your hands, whether you are walking this journey alone, working through the HOME, or somewhere in between.
          </p>
        </div>
      </div>
    </section>
  );
}